// extracted by mini-css-extract-plugin
var _1 = "DownloadGPXButton__DownloadGPXButton___y2uv7";
var _2 = "DownloadGPXButton__desktopOnly___aNKTV";
var _3 = "DownloadGPXButton__disabled___me9UY";
var _4 = "DownloadGPXButton__link___H21vn";
var _5 = "DownloadGPXButton__wiggle___Ikrf1";
export { _1 as "DownloadGPXButton", _2 as "desktopOnly", _3 as "disabled", _4 as "link", _5 as "wiggle" }
